import { ReactComponent as Icon } from 'assets/menuWide/verticalDivider.svg'
import React from 'react'

export default function VerticalDivider(props: any) {
  return (
    <Icon {...props} />
  )
}